export default __webpack_public_path__ + "static/media/right.270bf26f.mp3";